(() => {
  const doc = document.documentElement;
  const body = document.body;
  const hero = document.querySelector('[data-hero]');
  let lastScrollY = window.scrollY;
  let ticking = false;

  body.classList.remove('no-js');
  body.classList.add('is-loaded');

  const updateScrollState = () => {
    const y = window.scrollY;
    const max = Math.max(doc.scrollHeight - window.innerHeight, 1);
    body.classList.toggle('is-scrolled', y > 18);
    body.classList.toggle('header-hidden', y > 280 && y > lastScrollY + 6);
    doc.style.setProperty('--scroll-progress', String(Math.min(y / max, 1)));
    if (hero) {
      hero.style.setProperty('--hero-scroll', `${Math.min(y, 520) * -0.045}px`);
    }
    lastScrollY = y;
    ticking = false;
  };

  window.addEventListener('scroll', () => {
    if (!ticking) {
      window.requestAnimationFrame(updateScrollState);
      ticking = true;
    }
  }, { passive: true });
  updateScrollState();

  if (window.matchMedia('(pointer: fine)').matches) {
    let pointerTicking = false;
    let pointerX = window.innerWidth / 2;
    let pointerY = window.innerHeight / 2;

    window.addEventListener('pointermove', (event) => {
      pointerX = event.clientX;
      pointerY = event.clientY;
      body.classList.add('has-pointer');

      if (!pointerTicking) {
        window.requestAnimationFrame(() => {
          doc.style.setProperty('--cursor-x', `${pointerX}px`);
          doc.style.setProperty('--cursor-y', `${pointerY}px`);
          pointerTicking = false;
        });
        pointerTicking = true;
      }
    }, { passive: true });

    window.addEventListener('pointerleave', () => {
      body.classList.remove('has-pointer');
    });
  }

  const revealItems = [...document.querySelectorAll('[data-reveal]')];
  if ('IntersectionObserver' in window) {
    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.14 });

    revealItems.forEach((item) => revealObserver.observe(item));
  } else {
    revealItems.forEach((item) => item.classList.add('is-visible'));
  }

  if (hero) {
    hero.addEventListener('pointermove', (event) => {
      const rect = hero.getBoundingClientRect();
      const x = ((event.clientX - rect.left) / rect.width - 0.5) * 18;
      const y = ((event.clientY - rect.top) / rect.height - 0.5) * 14;
      hero.style.setProperty('--hero-x', `${x}px`);
      hero.style.setProperty('--hero-y', `${y}px`);
    });

    hero.addEventListener('pointerleave', () => {
      hero.style.setProperty('--hero-x', '0px');
      hero.style.setProperty('--hero-y', '0px');
    });
  }

  const tiltItems = [...document.querySelectorAll('[data-tilt]')];
  tiltItems.forEach((item) => {
    item.addEventListener('pointermove', (event) => {
      const rect = item.getBoundingClientRect();
      const x = (event.clientX - rect.left) / rect.width - 0.5;
      const y = (event.clientY - rect.top) / rect.height - 0.5;
      item.style.setProperty('--ry', `${x * 7}deg`);
      item.style.setProperty('--rx', `${y * -7}deg`);
    });

    item.addEventListener('pointerleave', () => {
      item.style.setProperty('--ry', '0deg');
      item.style.setProperty('--rx', '0deg');
    });
  });

  const magneticItems = [...document.querySelectorAll('.button')];
  magneticItems.forEach((item) => {
    item.addEventListener('pointermove', (event) => {
      const rect = item.getBoundingClientRect();
      const x = (event.clientX - rect.left - rect.width / 2) * 0.12;
      const y = (event.clientY - rect.top - rect.height / 2) * 0.16;
      item.style.setProperty('--magnet-x', `${x}px`);
      item.style.setProperty('--magnet-y', `${y}px`);
    });

    item.addEventListener('pointerleave', () => {
      item.style.setProperty('--magnet-x', '0px');
      item.style.setProperty('--magnet-y', '0px');
    });
  });


  const cookieBanner = document.querySelector('[data-cookie-banner]');
  const cookieAccept = document.querySelector('[data-cookie-accept]');
  if (cookieBanner && cookieAccept && window.localStorage.getItem('lahr_cookie_notice') !== 'ok') {
    cookieBanner.classList.add('is-visible');
    cookieAccept.addEventListener('click', () => {
      window.localStorage.setItem('lahr_cookie_notice', 'ok');
      cookieBanner.classList.remove('is-visible');
    });
  }

  document.querySelectorAll('a[href="#impressum"]').forEach((link) => {
    link.addEventListener('click', () => {
      const legal = document.getElementById('impressum');
      if (legal && legal.tagName === 'DETAILS') legal.open = true;
    });
  });

  document.querySelectorAll('a[href]').forEach((link) => {
    link.addEventListener('click', (event) => {
      const href = link.getAttribute('href') || '';
      if (
        event.defaultPrevented ||
        event.metaKey ||
        event.ctrlKey ||
        event.shiftKey ||
        event.altKey ||
        link.target ||
        link.hasAttribute('download') ||
        href.startsWith('#') ||
        href.startsWith('mailto:') ||
        href.startsWith('tel:')
      ) {
        return;
      }

      const url = new URL(link.href, window.location.href);
      if (url.origin !== window.location.origin || url.pathname === window.location.pathname && url.hash) {
        return;
      }

      event.preventDefault();
      body.classList.add('is-leaving');
      window.setTimeout(() => {
        window.location.href = url.href;
      }, 180);
    });
  });

  doc.style.setProperty('--viewport-ready', '1');
})();
